// 生成token 

import { currentUser, getCookie, setCookie } from "../util/utils"
import { axiosLang } from "../util/http";

let url = process.env.NODE_ENV == "development" ? 'https://cad-center.panzitech.com' : "https://cad-center.panzitech.com";
const applyId = process.env.NODE_ENV == "development" ? 14 : 14;
//生成访问那个地方的token
export const autoCreateUserAuth = async (boo = false) => {
    console.log(url);
    const cadToken = getCookie("cad_token");
    if (!boo && cadToken) {
        return cadToken
    }
    // user 之前是模块加载时读一次的顶层常量，phone.jsx 这类靠 url token 异步登录的场景里，
    // 这个模块往往在 window.__user__ 写入之前就已经被 import 过，创建 cad_token 时用的还是登录前的空 user，
    // 拿到的 cad_token 会一直被后面 !boo && cadToken 的缓存逻辑复用，相当于永久绑死成未登录身份。
    // 改成每次调用时才读，拿到的才是当下真实的登录状态
    const user = currentUser() || {}
    const axios = axiosLang();
    const { data } = await axios.post(`${url}/api/cad/auth/createUserAuth`, {

        "userId": user.id || "1000",
        "name": user.nickname || "未登录",
        "applyId": applyId,
        "nickName": "12365",
        "phone": "",
        "applyChinese": ""

    }, {
        headers: {
            "Content-Type": "application/json"
        }
    })
    console.log(data);
    if (data.success) {
        setCookie("cad_token", data.result, 7)
        return data.result
    }
}
// 文件转换 把dwg 转换为ocf 文件
export const dwgToOcf = async (token, params, callBack) => {
 
    try {
        const axios = axiosLang();
        const { data, } = await axios.post(`${url}/api/cad/convert/toOcf?token=${token}`, params)

        if (data.success) {
            return data.result
        } else {
            return data.error
        }
    } catch (error) {
        callBack()
    }

}
export const apiUrl = url;